<jb-dialog *ngIf="(flightTrackerText$ | async) as flightTrackerText">
  <jb-dialog-header
    >{{ dialogOrigin }} {{ flightTrackerText?.dialogLargeTitle }}
    {{ dialogDestination }}</jb-dialog-header
  >
  <jb-dialog-content>
    <div class="flex flex-row body">
      <div
        tabindex="0"
        *ngIf="!(dialogStatus | jbIncludesSubstring: 'TROUBLE')"
        class="flex flex-row w-25 pv2 b justify-center"
      >
        <div class="ph2">{{ flightTrackerText?.tabletStickyStatus }}</div>
        <span class="{{ setStatusColor(dialogStatus) }}">&#9679;</span>
        <div class="core-blue">{{ dialogStatus }}</div>
      </div>
      <div
        tabindex="0"
        *ngIf="
          !(dialogStatus | jbIncludesSubstring: 'TROUBLE') &&
          !(dialogStatus | jbIncludesSubstring: 'CANCELLED') &&
          dialogNewArrival !== null &&
          dialogNewDeparture !== null
        "
        class="flex flex-row w-50 pv2 justify-center"
      >
        <div class="ph2 b">{{ flightTrackerText?.dialogRemainingFlightTime }}</div>
        <div>{{ calculateRemainingTime(dialogNewArrival) }}</div>
      </div>
      <div tabindex="0" class="flex flex-row w-25 pv2 justify-center">
        <div>
          {{ flightTrackerText?.lastUpdated }}
          {{ currentTime | date: 'h:mma' | lowercase }}
        </div>
      </div>
    </div>
  </jb-dialog-content>
</jb-dialog>
